import { Box, FormControl, FormHelperText, FormLabel } from "@mui/material";
import React from "react";
import { Field } from "react-final-form";
import { FileDropper } from "../FileDropper";
import { FormFieldWrapper, FormFieldWrapperProps } from "./FormFieldWrapper";

export interface FileFormFieldProps
  extends Omit<FormFieldWrapperProps, "children"> {
  name: string;
  label?: string;
  description?: string;
  required?: boolean;
  multiFile?: boolean;
}

export const FileFormField: React.FC<FileFormFieldProps> = ({
  name,
  label,
  description,
  required,
  multiFile,
  ...wrapperProps
}) => {
  const fieldId = React.useId();
  const labelId = `${fieldId}-label`;
  const errorId = `${fieldId}-error`;

  return (
    <FormFieldWrapper {...wrapperProps}>
      <FormControl fullWidth>
        <FormLabel id={labelId} required={required}>
          {label}
        </FormLabel>
        <Field
          name={name}
          type="file"
          validate={(v) =>
            required && (v == null || (Array.isArray(v) && v.length == 0))
              ? "This field is required"
              : undefined
          }
          render={({ input, meta }) => (
            <>
              <FileDropper
                files={input.value == "" ? [] : input.value}
                onChange={input.onChange}
                multiFile={multiFile}
                description={description}
                aria-labelledby={label ? labelId : undefined}
                aria-label={
                  label
                    ? undefined
                    : description || (multiFile ? "Add files" : "Add a file")
                }
                aria-describedby={
                  meta.touched && meta.error ? errorId : undefined
                }
              />
              {meta.touched && meta.error && (
                <Box p={1}>
                  <FormHelperText id={errorId} error>
                    {meta.error}
                  </FormHelperText>
                </Box>
              )}
            </>
          )}
        />
      </FormControl>
    </FormFieldWrapper>
  );
};
